import { gql } from "@apollo/client";

export const TUTOR_CERTIFICATE_FIELDS = gql`
  fragment TutorCertificateFields on TutorCertificate {
    id
    firstname
    lastname
    personal_number
    date
    author {
      id
      name
      type
    }
    responsible
    # responsible {
    #   id
    #   email
    #   firstname
    #   lastname
    #   type
    # }
    responsible2
    # responsible2 {
    #   id
    #   email
    #   firstname
    #   lastname
    #   type
    # }
    region {
      id
      name
      title
      status
      certified
      logo2 {
        id
        title
        filename
        filesize
        filetype
        url
      }
      groups {
        id
        name
        title
        category
        groups {
          id
          name
          title
          category
        }
      }
    }
    local_id
    educator_id
    steps
    done
    created_at
    updated_at
    uid {
      id
      code
      created_at
    }
    scope
    step2
  }
`;

export const GET_TUTOR_CERTIFICATE = gql`
  query TutorCertificate($id: ID!) {
    certTutorCertificate(id: $id) {
      ...TutorCertificateFields
    }
  }
  ${TUTOR_CERTIFICATE_FIELDS}
`;

export const GET_TUTOR_CERTIFICATES = gql`
  query TutorCertificates(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetTutorCertificatesOrderByClause]
    $filters: [GetCertFilter]
  ) {
    certTutorCertificates(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
      filters: $filters
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        ...TutorCertificateFields
      }
    }
    allGroups(categories: ["region", "local", "educator"]) {
      id
      title
      category
      parentGroups {
        logo3 {
          id
          title
          url
        }
      }
    }
  }
  ${TUTOR_CERTIFICATE_FIELDS}
`;
